import { render, staticRenderFns } from "./AdvertisingMap.vue?vue&type=template&id=120f2366&scoped=true&"
import script from "./AdvertisingMap.vue?vue&type=script&lang=js&"
export * from "./AdvertisingMap.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingMap.vue?vue&type=style&index=0&id=120f2366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f2366",
  null
  
)

export default component.exports